import { cancelOrder, takeOrder, delOrder, payOrder, payOrder2 } from "@api/order";
import dialog from "@utils/dialog";
 import { pay } from "@libs/wechat";
import router from "../router";
import { isWeixin } from "@utils";

export function cancelOrderHandle(orderId) {
  return new Promise((resolve, reject) => {
    dialog.confirm({
      mes: "确认取消该订单?",
      opts() {
        cancelOrder(orderId)
          .then(res => {
            dialog.success("取消成功");
            resolve(res);
          })
          .catch(err => {
            dialog.error("取消失败");
            reject(err);
          });
      }
    });
  });
}

export function takeOrderHandle(orderId) {
  return new Promise((resolve, reject) => {
    takeOrder(orderId)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        dialog.error("收货失败");
        reject(err);
      });
  });
}

export function delOrderHandle(orderId) {
  return new Promise((resolve, reject) => {
    dialog.confirm({
      mes: "确认删除该订单?",
      opts() {
        delOrder(orderId)
          .then(res => {
            dialog.success("删除成功");
            resolve(res);
          })
          .catch(err => {
            dialog.error("删除失败");
            reject(err);
          });
      }
    });
  });
}

export function payOrderHandle(orderId, type, from) {
  return new Promise((resolve, reject) => {
    payOrder2(orderId, type, from)
      .then(res => {
        console.log("???");
        const data = res.data;
        console.log(data);
        dialog.loading.close();
        switch (data.status) {
          case "WECHAT_H5_PAY":
            setTimeout(() => {
              window.location.href = data.result.jsConfig.results.payScheme;
            }, 100);
            break;
          case "ORDER_EXIST":
          case "EXTEND_ORDER":
          case "PAY_ERROR":
          case "PAY_DEFICIENCY":
            dialog.toast({ mes: res.msg });
            reject(data);
            break;
          case "ALIPAY_PAY":
            console.log("alipay");
            if (isWeixin()) {
              router.push({
                path: `/order/openAlipay?order_id=${
                  data.result.jsConfig.results.orderNo
                }`
              });
            } else {
              window.location.href = data.result.jsConfig.results.payScheme;
            }
            break;
          case "UNIONPAY_PAY":
            console.log("银联支付");
            console.log(data.result.jsConfig);
            router.push({
              name: `UnionPay`,
              params: { jsconfig: data.result.jsConfig }
            });
            break;
          case "SUCCESS":
            dialog.success(res.msg);
            resolve(data);
            break;
          case "WECHAT_PAY":
            /*
            setTimeout(() => {
              window.location.href = data.result.jsConfig.results.payScheme;
            }, 100);
            break;*/
            
            pay(data.result.jsConfig).then(() => {

              resolve(data);

            });
            break;
        }
      })
      .catch(err => {
        console.log(err);
        dialog.loading.close();
        dialog.toast({ mes: err.msg || "订单支付失败" });
      });
  });
}
